import {useCallback, useEffect, useRef} from 'react';

import {getUrlParameter} from '@optimaxdev/utils';

import {useSelector} from 'react-redux';

import {STEPS} from '../../constants/checkout';

import {getCurrentStep} from '../../store/selectors/currentStep/currentStep';
import {isDeliveryStepLoaded} from '../../store/selectors/deliveryStep/deliveryStep';

/**
 *  open payment step when token is valid
 */
export const useOpenPaymentStepIfValidToken = (
    {clearErrors, trigger}: {clearErrors: () => void; trigger: () => Promise<boolean>},
    goToPaymentStep: () => void,
) => {
    const currentStep = useSelector(getCurrentStep);
    const isLoaded = useSelector(isDeliveryStepLoaded);
    const isNavigatedByTokenRef = useRef(false);
    const openPaymentStepIfValidToken = useCallback(async () => {
        if (isNavigatedByTokenRef.current) return;
        isNavigatedByTokenRef.current = true;
        const cartToken = getUrlParameter('token');
        if (!cartToken) return;

        const isValid = await trigger();
        clearErrors();
        if (isValid) goToPaymentStep();
    }, [goToPaymentStep, clearErrors, trigger]);

    useEffect(() => {
        if (currentStep === STEPS.DELIVERY_STEP && isLoaded) openPaymentStepIfValidToken();
    }, [isLoaded, currentStep, openPaymentStepIfValidToken]);
};
